import React, { useState } from 'react';
import PersonSearch from '@mui/icons-material/PersonSearch';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import CheckIcon from '@mui/icons-material/Check';
import { priority } from 'Constants/Database';
import { styleIcon } from '../style';

export default function SelectIcon({ priorityType = priority.Normativa }) {
  if (priorityType === priority.Normativa) {
    return <PersonOffIcon sx={{ fontSize: 40 }} style={styleIcon} />;
  }
  if (priorityType === priority.Institucional) {
    return <PersonSearch sx={{ fontSize: 40 }} style={styleIcon} />;
  }
  return <CheckIcon sx={{ fontSize: 40 }} style={styleIcon} />;
}
